/**
 * Formats a price in pence to a GBP currency string
 * @param priceInPence Price in pence (e.g., 1250 = £12.50)
 * @returns Formatted price string (e.g., "£12.50")
 */
export const formatPrice = (priceInPence: number): string => {
  return `£${(priceInPence / 100).toFixed(2)}`;
};

/**
 * Maximum physical size in millimeters (16 inches)
 */
export const MAX_PHYSICAL_SIZE_MM = 406;
